import React from 'react'
import { pageAndHomeworkHelperText } from '../../helpers/mergeFieldHelperText'

const style = {
  icon: {
    width: 'inherit'
  }
}

const iconOptions = [
  { value: 'info', name: 'Info' },
  { value: 'home', name: 'Home' },
  { value: 'group', name: 'My Group' },
  { value: 'homework', name: 'Homework' },
  { value: 'progress', name: 'My Data' },
  { value: 'calendar', name: 'Calendar' },
  { value: 'forums', name: 'Community Forums' },
  { value: 'book', name: 'Resources' },
  { value: 'private_coaching', name: 'Private Coaching' }
].map(option => {
  return { ...option, icon: <img style={style.icon} src={`/images/nav-${option.value}-active.png`} /> }
})

export default [
  { name: 'Program', prop: 'program_id', type: 'autocomplete', references: 'admin/programs', referenceProp: 'name' },
  { name: 'Title', prop: 'title', type: 'text' },
  { name: 'Icon', prop: 'icon', type: 'select', options: iconOptions },
  { name: 'Sort Order', prop: 'sort_order', type: 'number' },
  {
    name: 'Text',
    prop: 'text',
    type: 'wysiwyg',
    helperText: pageAndHomeworkHelperText
  },
  { name: 'Restricted Access', prop: 'has_restricted_access', type: 'checkbox' }
]
